mutation ToggleFacebookInstagramIsEnabled {
    toggleFacebookInstagramIsEnabled
}
